import { createContext } from 'react';
import type { ConfigProviderProps } from '../components/config-provider';

const ConfigProviderContext = createContext<Pick<ConfigProviderProps, 'h5JsApiReady'>>({});

ConfigProviderContext.displayName = 'ConfigProviderContext';
export default ConfigProviderContext;
